import React, {useEffect, useState} from 'react';
import classnames from 'classnames';
import StylesType from '@/types/StylesType';
import {Collapse, Checkbox, Badge, Row, Col, Icon as AIcon, Popconfirm, message, Typography,Tooltip } from 'antd';
import {Button, Icon} from '@/components';
import TweenOne from 'rc-tween-one';
import {groupTypes} from '@/types/APITypes';
import secondToDay from '@/utils/secondToDay';
import * as R from 'ramda';
import {View} from '@/components'

import './style';
import copy from 'copy-to-clipboard';

export interface GroupProps extends StylesType {
  groupDataSource: groupTypes[]
  deviceDataSource: any,
  onChange: (e: any) => void;
  selectOptions: any,
  activeKey: string | number;
  activeGroupId: string | number
}

export const GroupHead: React.FC<StylesType> = props => {

    const {prefixCls} = props;

    useEffect(() => {
    },)

    return (
        <div className={`${prefixCls}-head`}>
            <span>云机名称</span>
            <span>状态</span>
            <span>剩余时间</span>
        </div>
    )

}

export const GroupOption: React.FC<GroupProps & {options: any}> = props => {

  const {prefixCls, options, onChange, selectOptions} = props;
  
  let status: any = 'success'
  
  const {phoneOpType, phoneStatus} = options;
  
  const types = [203,204,201,202,101,102,103,104,401,106,105,501,502,503]
  
  if (options.deviceSaasStatus === 0) {
    
    if (phoneStatus === 2) {
      status = 'success'
    } else if(types.indexOf(phoneOpType) !== -1) {
      status = 'yellow'
    }
    
  } else {
    status = 'red'
  }

  /* 点击分组单选 */
  const handleCheckbox = (e: any) => {
    onChange({type: 'checkbox', key: e.target.checked, value: options.cid })
  }
  
  /* 点击修改名称 */
  const handleIconEdit = (e: any) => {
    onChange({type: 'edit', key: e.target.checked, value: options.cid })
  }

  return (
        <div className={`${prefixCls}-option`}>
            <Checkbox className={`${prefixCls}-option-checkbox`} checked={R.includes(options.cid,selectOptions.checkedList)} onChange={handleCheckbox}>
              <Tooltip title={options.deviceName || options.cid}>
              <Typography.Text style={{width: 100,verticalAlign: 'bottom'}} ellipsis={true}>
                {options.deviceName || options.cid}
              </Typography.Text>
              </Tooltip>
            </Checkbox>
              <div className={`${prefixCls}-hover`}>
                <Icon onClick={handleIconEdit} style={{marginRight: 20}}  type='iconEdit' />
                <Popconfirm
                  icon={null}
                  placement="topLeft"
                  title={`当前云机设备号：${options.cid}`}
                  okText="复制"
                  cancelText="取消"
                  onConfirm={() => {
                    copy(options.cid)
                    message.success('复制成功！');
                  }}
                >
                  <Icon type='iconfind'/>
                </Popconfirm>
              </div>
           
              <div className={`${prefixCls}-default`}>
                <Badge status={status}/>
                <span style={{
                  color: options.endTime - 1800 - Number(Math.round(new Date().getTime() / 1000).toString()) < 86400 ?
                    'red' : '#000'
                }}>{
                  secondToDay(
                    options.endTime - 1800 - Number(Math.round(new Date().getTime() / 1000).toString())
                  )}</span>
              </div>
  
        </div>
    )

}

export const Group: React.FC<GroupProps> = props => {

    const {prefixCls, className, style, groupDataSource, onChange, deviceDataSource, selectOptions, activeGroupId} = props;

    const [moment, setMoment] = useState(undefined);

    const [paused, setPaused] = useState(true);

    const [reverse, setReverse] = useState(true);

    const [activeKeyId, setActiveKeyId] = useState(-1)
    const [activeKeyIdState, setActiveKeyIdState] = useState(-1)
  
  
  const onReverse = () => {
        setPaused(false)
        // @ts-ignore
      setMoment(null)
        setReverse(true)
    }

    const onClick = () => {
        setPaused(false)
        // @ts-ignore
      setMoment(null)
        setReverse(false)
    }


    const {Panel} = Collapse;

    const customPanelStyle = {
        marginLeft: -20,
        border: 0,
        padding: 0,
        overflow: 'hidden',
    };

    const animation =  { left: '-94%', width: 30,duration: 1000 };

    /* 点击分组全选 */
     const handleCheckboxAll = (e: any) => {
       setActiveKeyId(e.target['data-key'])
       setActiveKeyIdState(e.target['data-key'])
       onChange({type: 'checkboxAll', key: e.target.checked, value: Number(e.target['data-key']) })
     }


  /* 分组展开/折叠 */
  const handleCollapse = (key: any) => {
    console.log(key);
    setActiveKeyIdState(key)
    if (key) {
      onChange({type: 'collapse', key: key })
      setActiveKeyId(key)
    }
  }

  /* 点击新建 */
  const handleButton = () => {
    onChange({type: 'button'})
  }

  const handleIcon = (e: any,item: any) => {
    e.persist();
    const key = e.target.parentNode.parentNode.parentNode.getAttribute('data-name')
    onChange({type: 'icon',key,value: item.id, groupName: item.groupName})
  }
  
  
  if (groupDataSource.length === 0 ) return <></>

  return (
        <>
            <TweenOne
                style={{position: 'relative',left: '0'}}
                animation={animation}
                paused={paused}
                reverse={reverse}
                moment={moment}
            >
                <div className={classnames(prefixCls, className, style)}>
                    <Button onClick={handleButton} type="primary" block size='lg'><Icon type='iconxinjianicon'/>新建分组</Button>
                    <View.ScrollView bottomHeight={78}>
                      <Collapse
                        activeKey={activeKeyIdState}
                        onChange={handleCollapse}
                        accordion
                        bordered={false}
                        expandIcon={({isActive}) => <Icon type="iconshushouqi" rotate={isActive ? 90 : 0}/>}
                      >
                        {groupDataSource.map((item:any) =>
                          <Panel header={
                            <Row justify='space-between' type='flex' onClick={e => e.stopPropagation()}>
                              <Col>
                                <Checkbox
                                  data-key={item.id}
                                  indeterminate={selectOptions.indeterminate && Number(activeKeyId) === item.id}
                                  checked={selectOptions.checkAll && Number(activeKeyId) === item.id && Number(activeGroupId) === Number(activeKeyId)}
                                  onChange={handleCheckboxAll}
                                >
                                  {`${item.groupName} (${item.deviceCount})`}
                                </Checkbox>
                              </Col>
                              <Col>
                                {item.isDefault === 0 ?
                                  <Row type='flex' gutter={16}>
                                    <Col  data-name='edit'><Icon onClick={(e) => handleIcon(e,item)} type='iconEdit' /></Col>
                                    <Col  data-name='delete'><Icon onClick={(e) => handleIcon(e,item)} type='iconshanchuzu' /></Col>
                                  </Row>:
                                  null
                                }
                              </Col>
                            </Row>
                          } key={item.id} style={customPanelStyle}>
                            {deviceDataSource.map((item: any) => <GroupOption options={item} key={item.id} {...props}></GroupOption>)}
                          </Panel>
                        )}
                      </Collapse>
                    </View.ScrollView>

                </div>
              <AIcon onClick={reverse? onClick: onReverse} className={reverse ? 'gc-group-icon' : 'gc-group-icon-left'} type={reverse ? 'double-left': 'double-right'} />
            </TweenOne>
        </>
    )

}

GroupHead.defaultProps = {
    prefixCls: 'gc-group'
}

GroupOption.defaultProps = {
    prefixCls: 'gc-group'
}

Group.defaultProps = {
    prefixCls: 'gc-group'
}

export default Group;
